import { Flex, SearchRoundedIcon, Text } from '@shared/components';

export default function IncompleteTopicAndSubTopicOverlay() {
  return (
    <Flex
      sx={(theme) => ({
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
        py: theme.spacing(4),
      })}
    >
      <SearchRoundedIcon color='secondary' sx={{ fontSize: '48px' }} />
      <Text variant='h5' color='textSecondary'>
        เลือก Topic และ Sub-Topic เพื่อดูคำถามในคลัง
      </Text>
    </Flex>
  );
}
